import { Inject, Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { CrmDependencies, CrmInjectionToken, ProfileCard } from '@galaxy/crm/static';

@Injectable()
export class ContactProfileCardsPanelService {
  public readonly contactProfileCards$: Observable<ProfileCard[]>;

  constructor(@Inject(CrmInjectionToken) private readonly config: CrmDependencies) {
    this.contactProfileCards$ = this.config.contact?.profileCards$ ?? EMPTY;
  }
}
